export const SIDEBAR_DEFAULT_RUN_TO_WIN_LINK = 'https://runtowin.ai/';

export function getRunToWinLinkFromState() {
  if (typeof document === 'undefined') {
    return SIDEBAR_DEFAULT_RUN_TO_WIN_LINK;
  }

  const stateInput = document.getElementById('state-at-load');

  if (!stateInput || !stateInput.value) {
    return SIDEBAR_DEFAULT_RUN_TO_WIN_LINK;
  }

  try {
    const state = JSON.parse(stateInput.value);
    return state.runToWinLink || SIDEBAR_DEFAULT_RUN_TO_WIN_LINK;
  } catch (e) {
    return SIDEBAR_DEFAULT_RUN_TO_WIN_LINK;
  }
}

export const SIDEBAR_MAIN_ITEMS = [
  { id: 'home', label: 'Latest', icon: 'fa-compass' },
  { id: 'campaigns', label: 'Campaigns', icon: 'fa-podium' },
  { id: 'community', label: 'Community', icon: 'fa-people-arrows' },
  { id: 'news', label: 'News', icon: 'fa-rss-square' },
];

export const SIDEBAR_MORE_ITEMS = [
  { id: 'groups', label: 'Groups', icon: 'fa-user-friends' },
  { id: 'petitions', label: 'Petitions', icon: 'fa-file-signature' },
  { id: 'representatives', label: 'Representatives', icon: 'fa-landmark', truncateOnSmallDesktop: true },
  { id: 'members', label: 'Members', icon: 'fa-users' },
  { id: 'active_races', label: 'Races', icon: 'fa-flag-usa' },
  { id: 'events', label: 'Events', icon: 'fa-calendar-day' },
  { id: 'polls', label: 'Polls', icon: 'fa-poll' },
  { id: 'blogs', label: 'Blogs', icon: 'fa-edit' },
];

export const SIDEBAR_CATEGORY_ROUTES = {
  home: '/feed',
  campaigns: '/campaigns',
  community: '/community',
  news: '/news',
  groups: '/groups',
  polls: '/polls',
  representatives: '/representatives',
  members: '/members',
  active_races: '/active_races',
  events: '/events',
  petitions: '/petitions',
  blogs: '/blogs',
  tv: '/tv',
};

export const SIDEBAR_VALID_CATEGORIES = [
  'home',
  'community',
  'news',
  'tv',
  'petitions',
  'members',
  'campaigns',
  'active_races',
  'blogs',
  'representatives',
  'polls',
  'groups',
  'events',
];
